import { Container, Grid, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import PropTypes from 'prop-types';
import Collections from '../../components/Collections';
import Wysiwyg from '../../components/Wysiwyg';

function Cuisines(props) {
  const { cuisines, title, description, imageUrl } = props;

  return (
    <Box>
      {!!imageUrl &&
        <Stack
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Grid
            className='collection_img_container'
            item
            sm={12}
            sx={{
              my: 3,
              width: '100%',
              height: '500px',
              overflow: 'hidden',
            }}
          >
            <img
              className="collection_img"
              src={imageUrl}
              alt={title}
              width="1600"
              height="500"
              loading="eager"
              decoding="async"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block',
              }}
            />
          </Grid>
        </Stack>
      }

      <Typography
        sx={{
          textAlign: 'justify'
        }}
        component="div"
      >
        <Wysiwyg>
          {description}
        </Wysiwyg>
      </Typography>

      <Collections collections={cuisines} />
    </Box>
  )
}

Cuisines.propTypes = {
  cuisines: PropTypes.array,
  description: PropTypes.string.isRequired,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
}

export default Cuisines